import { ApiV1Response, http } from 'api/v1/http'
import { UserId } from 'types'

export enum SlotType {
  Spot,
  Perp,
}
export interface GetSlotResponse {
  userId: UserId // 10036
  nonce: number
  slotId: number
  available: boolean
}
export async function getSlot<T extends ApiV1Response<GetSlotResponse>>(
  slotType: SlotType
): Promise<T> {
  const r = await http.get<T>(`/orderNonce/gen/${slotType}`)
  return r.data
}

export async function getMultiSlots<T extends ApiV1Response<GetSlotResponse[]>>(
  slotType: SlotType,
  size: number
): Promise<T> {
  const r = await http.get<T>(`/orderNonce/gen/${slotType}/${size}`)
  return r.data
}
